// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1jSCe","bigColWidth":"Table_bigColWidth__1r_gE","biggerColWidth":"Table_biggerColWidth__2eLIg","row":"Table_row__Rixa5","col":"Table_col__eRJQc"};